// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { useGet } from 'hooks';
import VirtualizedAutoComplete from 'components/__v5__/MuiAutoComplete/VirtualizedAutoComplete';
import { useStyles } from './style';
import { CautionIcon } from '../YesNoNaFormFieldPreview/config/yesnonaSvgs';

const MultipleSelectFieldPreview = ({
  element,
  answer,
  handleDirty,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const [, { setSelectedLinkListLabel, setAnswer }] = useCustomForm();
  const { data: linkData } = useGet('v1.1/custom-form/get_linked_choices/', {
    query: { choice_id: element?.islinked_query, page: 1, per_page: 10000 },
  });
  const [selectedChoices, setSelectedChoices] = useState([]);

  const classes = useStyles();
  const isFromManualList = !element?.fromManualList;
  const isMultipleSelect = element.type === 'multipleselect';

  useEffect(() => {
    const choices = !element?.fromManualList ? linkData?.data : element?.choice;
    const answerArray =
      typeof answer === 'string' ? answer?.split(',') : answer;

    const newSelectedChoices =
      choices?.filter((choice) => answerArray?.includes(choice.id)) || [];

    setSelectedChoices(newSelectedChoices);
  }, [answer, linkData?.data]);

  const handleSelectionChange = (newValues) => {
    const selectedValues = Array.isArray(newValues) ? newValues : [newValues];
    setSelectedChoices(selectedValues);

    const selectedIds = selectedValues?.map((value) => value?.id);
    const newSelectedId = selectedIds.join(',');

    const selectedLabels = selectedValues?.map((value) => value?.label);
    const newSelectedLabels = selectedLabels.join(',');

    setSelectedLinkListLabel(element.id, newSelectedLabels);
    setAnswer(element.id, newSelectedId);
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(
        element?.id,
        newSelectedId,
        element?.type,
        newSelectedLabels,
      );
    }
    handleDirty();
  };

  const isNeedAction = selectedChoices?.find((value) => value?.action);

  return (
    <Box key={element?.id} m={1}>
      <FieldsInputTitle
        label={element?.label || element?.name}
        isRequired={element?.isRequired}
      />

      <VirtualizedAutoComplete
        id="notify-to-autocomplete"
        optionData={
          isFromManualList ? linkData?.data || [] : element?.choice || []
        }
        value={
          !isMultipleSelect && selectedChoices?.length > 0
            ? selectedChoices[0]
            : selectedChoices
        }
        placeholder={`Select ${element?.islinked_query || 'Options'}`}
        datatestid="notify-to"
        setValue={handleSelectionChange}
        getOptionLabel={(option) => option?.label || ''}
        multiple={isMultipleSelect}
        style={{ width: '100%' }}
        loading={false}
        getOptionGroup={null}
        disabled={shouldBeReadOnly}
      />

      {isNeedAction?.action && (
        <Box className={classes.cautionBox}>
          <span style={{ marginLeft: 5 }}>{CautionIcon}</span>
          <Typography className={classes.cautionText} variant="body2">
            {element?.actionMessage || (
              <> Warning ! You are selecting the field that needs action ! </>
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default MultipleSelectFieldPreview;
